import { useEffect } from "react";

import { inject, observer } from "mobx-react";

import Cookies from "../../components/Cookies";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import List from "../../components/Main/List";

import Modal from "../Modal";

import "./style.scss";
// import TopBar_AB_1662 from "../../components/TopBar_AB_1662"; 15/01/26 еще не запущен
import Geolocation from "../../components/Geolocation/Default";

// import { Suspense, lazy } from "react";
// const TopBar_AB_1662 = lazy(() => import("../../components/TopBar_AB_1662"));
// const Geolocation = lazy(() => import("../../components/Geolocation/Default"));

const Main = inject("mainStore")(
    observer(({ mainStore }) => {
        const isVisible = mainStore.getMainStore("isVisible");
        const isCoverRoot = mainStore.getMainStore("isCoverRoot");
        // const init = mainStore.getMainStore("init");
        // const ver = init?.data?._ab_m?.["dev_1662_28.11.2025"]?._d?.colorHeader;

        useEffect(() => {
            window.scrollTo(0, 1);
        }, []);

        return (
            <>
                {isVisible && (
                    <div className="main-container">
                        {/* удалить как в ios26 пофиксят прозрачность полосок браузера */}
                        {isCoverRoot ? <div className="main-container__cover" /> : null}
                        {/* удалить как в ios26 пофиксят прозрачность полосок браузера */}
                        <Header />
                        {/* <Suspense fallback={null}>{ver === "v2" ? <TopBar_AB_1662 /> : <Geolocation />}</Suspense> */}
                        <Geolocation />
                        <List />
                        <Footer />
                    </div>
                )}
                <Cookies />
                <Modal />
            </>
        );
    }),
);

export default Main;
